import PrimaryButton from './primary-button.vue';

export {
    PrimaryButton
};



// WEBPACK FOOTER //
// ./src/utils/components/index.js